import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { STUDENT_STORAGE_KEYS } from "../../services/StudentPortal/studentStorageKeys";

// Mirrors src/components/ProtectedRoute.js but guards the StudentPortal
// routes with the separate "studentToken" (auth:student_api / OTP login),
// which is independent from the staff "token" used everywhere else.
const StudentProtectedRoute = ({ component: Component }) => {
  const token = localStorage.getItem(STUDENT_STORAGE_KEYS.TOKEN);
  return token ? (
    <Component>
      <Outlet />
    </Component>
  ) : (
    <Navigate to="/student-portal/login" />
  );
};

export default StudentProtectedRoute;
